import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import DateTime from '../../../components/DateTime';
import { jsonToCSS } from '../../../helpers/styles';
import { onFormatDate, onFormatUTCTime } from '../../../utils/dateUtils';
import { colors, dimension } from '../WindowConfig';
import Column from './common/Column';
import LabelContainer from './common/LabelContainer';
import Row from './common/Row';
import ValueContainer from './common/ValueContainer';

interface IGeneralInfoAreaProps {
  style?: any;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${jsonToCSS(dimension.generalInfoArea)};
  color: ${colors.greenText};
`;

const RowContainer = styled(Row)<any>`
  ${({ width = '80%' }) => {
    return `width: ${width}`;
  }};
`;

const GeneralInfoArea: React.FC<IGeneralInfoAreaProps> = (props) => {
  const showGeneralInfoArea = useSelector(
    (state: any) => state.executor.s80.tacsit.showGeneralInfoArea
  );
  if (showGeneralInfoArea) {
    return (
      <Container {...props}>
        <RowContainer>
          <Column width="40%">
            <Row>
              <LabelContainer width="40%">DATE:</LabelContainer>
              <ValueContainer width="60%">
                <DateTime isLive onFormat={onFormatDate} />
              </ValueContainer>
            </Row>
          </Column>
          <Column width="60%">
            <Row>
              <LabelContainer width="25%">TIME:</LabelContainer>
              <ValueContainer width="60%">
                <DateTime isLive onFormat={onFormatUTCTime} />
              </ValueContainer>
            </Row>
          </Column>
        </RowContainer>
        <RowContainer width="90%">
          <Column width="40%">
            <Row>
              <LabelContainer width="70%">RANGE SCALE:</LabelContainer>
              <ValueContainer width="20%">64</ValueContainer>
            </Row>
          </Column>
          <Column width="60%">ORIENTATION: NORTH-UP</Column>
        </RowContainer>
      </Container>
    );
  }
  return null;
};

export default GeneralInfoArea;
